/**
 * Report generation functionality
 */
(function () {
  "use strict";

  function getCurrentMonthRange() {
    var now = new Date();

    return {
      firstDay: new Date(now.getFullYear(), now.getMonth(), 1),
      lastDay: new Date(now.getFullYear(), now.getMonth() + 1, 0),
    };
  }

  function formatDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");

    return year + "-" + month + "-" + day;
  }

  // Initialize datepickers for the report modal
  function initDatepickers() {
    if ($.fn.datepicker) {
      $(".js-report-from-date-picker, .js-report-to-date-picker").datepicker({
        format: "yyyy-mm-dd",
        autoclose: true,
      });

      // Add custom CSS to make the datepicker cells wider
      $("<style>")
        .prop("type", "text/css")
        .html(
          "\
          .ui-datepicker table td, .ui-datepicker table th { width: 45px !important; height: 45px !important; }\
        "
        )
        .appendTo("head");
    }
  }

  // Handle the report button click
  function setupReportButton() {
    $(".js-report-modal").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var range = getCurrentMonthRange();

      // Set default dates
      $(".js-report-from-date-picker").val(formatDate(range.firstDay));
      $(".js-report-to-date-picker").val(formatDate(range.lastDay));

      // Show the modal
      $("#reportModal").modal({
        backdrop: true,
        keyboard: true,
      });
    });
  }

  // Handle the confirm button in the report modal
  function setupReportConfirmButton() {
    $(".js-report-confirm").on("click", function () {
      var fromDate = $(".js-report-from-date-picker").val();
      var toDate = $(".js-report-to-date-picker").val();

      if (!fromDate || !toDate) {
        alert("Pasirinkite abu laikotarpio datas");
        return;
      }

      // Close the modal
      $("#reportModal").modal("hide");

      // Generate the report by redirecting to the report endpoint
      // This will trigger a file download
      window.location.href =
        "/order/report/generate?from_date=" + fromDate + "&to_date=" + toDate;
    });
  }

  // Initialize all functionality
  function init() {
    initDatepickers();
    setupReportButton();
    setupReportConfirmButton();
  }

  // Initialize when the document is ready
  $(document).ready(init);
})();
